import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/types';
import {
    Root,
    FilterContainer,
    ButtonFilter,
    MenuFilter,
    Container,
    List,
    Label,
} from './styles';
import { ReactComponent as FilterIcon } from 'common/images/icon-filter.svg'
import FilterCheck from 'components/Filter';
import Search from '../Search';
import { getFiltersAPI } from './state/actions';
import { FilterItem } from 'features/Dealers/Performance/Filter/state/types';

export interface IState {}

export interface IProps {
    filters:  FilterItem[];
    onChange: (value:any, type:string, add:boolean) => void;
    openMenu: any;
}

const Filter: React.FC<IProps> = (props) => {
    const [showMenu, setShowMenu] = useState(false)
    const [plataforms, setPlataform] = useState([] as any)
    const [status, setStatus] = useState([] as any)
    const dispatch = useDispatch();    
    const tags: { offerTypes: [], OEMs: [] } = { offerTypes: [], OEMs: [] }
    const componentRef = useRef(null);

    const rootProps = useSelector((rootState: RootState) => {
        return {
            filtersItems: rootState.dealers.performanceFilters.items
        }
    }, shallowEqual);

    const fetchTags = () => {
        // return new Promise((resolve, reject) => {
        //   dispatch(actions.tags.fetchTags((result, error) => {
        //     if (error) reject(error);
        //     else resolve(result);
        //   }))
        // });
    }

    const handleClick = (e: any) => {
        if (componentRef && componentRef.current) {
            const ref: any = componentRef.current
            if (!ref.contains(e.target)) {
                setShowMenu(false);
            }
        }
    }

    useEffect(() => {
        if(rootProps.filtersItems==undefined)
        {
            dispatch(getFiltersAPI());
        }
        const run = async () => await fetchTags();
        run();

        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
    }, [])

    useEffect(() => {
        if(rootProps.filtersItems!=undefined)
        {
            setStatus(rootProps.filtersItems);
        }
    }, [rootProps.filtersItems])
    

    const handleClickBtnFilter = () => setShowMenu(!showMenu);
    const handleChangeFilters = (value: any, type: string, add: boolean) => props.onChange(value, type, add);

    return (
        <Root>
            <Search openMenu={props.openMenu} />

            <FilterContainer ref={componentRef}>
                <ButtonFilter onClick={handleClickBtnFilter}>
                    <FilterIcon style={{ display: 'inline-block', verticalAlign: 'middle', marginLeft: "5px", marginRight: "16px" }} />
                    Filter
                </ButtonFilter>

                {tags &&
                    <MenuFilter style={{
                        display: showMenu ? 'block' : 'none',
                        width: !props.openMenu ? `calc(74vw - ${295 + 64}px)` : `calc(74vw - 64px)`
                    }} >
                        <Container >
                            <List>
                                <Label>Activity</Label>
                                {status.map((value: any, index: number) =>
                                {                                                                                                
                                    return(
                                    <FilterCheck
                                        key={`status${index}`}
                                        label={value.displayName}
                                        type="templateStatus"
                                        onChange={handleChangeFilters}
                                        checked={props.filters['templateStatus'].includes(value.displayName)}
                                         />)}
                                )}
                            </List>
                        </Container>
                    </MenuFilter>
                }
            </FilterContainer>

        </Root >
    );
}

export default Filter;